module.exports = __webpack_public_path__ + "static/media/video_land.255c9964.mp4";